import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class CustomerTypes {
  static byEmail: IActionType = new ActionType('CUSTOMER/LOAD_BY_EMAIL');
  static byId: IActionType = new ActionType('CUSTOMER/LOAD_BY_ID');
  static updateCustomer: IActionType = new ActionType('CUSTOMER/LOAD_BY_EMAIL');
  static sendCustomerSurvey: IActionType = new ActionType('CUSTOMER/SEND_SURVEY');
  static markOrbitaAbandonment: IActionType = new ActionType('CUSTOMER/MARK_ORBITA_ABANDONMENT');
  static hasCoproductionGains: IActionType = new ActionType('CUSTOMER/HAS_COPRODUCTION_GAINS');
}

export default CustomerTypes;
